import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Box from '@mui/material/Box';

import {
  HOUR_MINUTE_SECONDS,
  MILITARY_TIME
} from 'bento-ordering/base/constants/timeFormat';

import DatePicker from 'bento-ordering/base/ui_components/DatePicker';
import TimePicker from 'bento-ordering/base/ui_components/TimePicker';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import Select from 'components/Select';
import { toTitleCase } from 'bento-ordering/base/utils/textUtils';
import { ALL_ONLINE_ORDERING_FULFILLMENT_METHODS } from 'constants/fulfillmentOptions';
import ErrorMessageTypography from 'components/ErrorMessageTypography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

class LocationDateTime extends React.Component {
  static propTypes = {
    primaryButtonLabel: PropTypes.string.isRequired,
    selectedDate: PropTypes.string,
    selectedTime: PropTypes.string,
    fulfillmentIsAsap: PropTypes.bool,
    areCartItemsAvailable: PropTypes.bool.isRequired,
    fulfillmentAsapLaterOptions: PropTypes.array.isRequired,
    fulfillmentHourOptions: PropTypes.array.isRequired,
    fulfillmentDateOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
    areFulfillmentOptionsValid: PropTypes.bool.isRequired,
    handleTimeChange: PropTypes.func.isRequired,
    handleDateChange: PropTypes.func.isRequired,
    handleAsapLaterSelectChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    fulfillmentMethod: PropTypes.oneOf(ALL_ONLINE_ORDERING_FULFILLMENT_METHODS)
      .isRequired,
    isValidatingAddress: PropTypes.bool
  };

  static defaultProps = {
    fulfillmentIsAsap: null,
    selectedDate: '',
    selectedTime: '',
    isValidatingAddress: false
  };

  render() {
    const {
      primaryButtonLabel,
      selectedDate,
      selectedTime,
      areCartItemsAvailable,
      fulfillmentIsAsap,
      fulfillmentAsapLaterOptions,
      fulfillmentDateOptions,
      areFulfillmentOptionsValid,
      fulfillmentHourOptions,
      handleTimeChange,
      handleDateChange,
      handleAsapLaterSelectChange,
      handleSubmit,
      fulfillmentMethod,
      isValidatingAddress
    } = this.props;
    const isDisabled = isValidatingAddress || !areFulfillmentOptionsValid;
    return (
      <Box mt={2.5}>
        <form onSubmit={handleSubmit}>
          <Select
            id="time-select"
            label={`${toTitleCase(fulfillmentMethod)} time`}
            onChange={handleAsapLaterSelectChange}
            value={fulfillmentIsAsap ? 1 : 0}
            options={fulfillmentAsapLaterOptions}
            fullWidth
            dataTestId="time-select"
          />

          {fulfillmentIsAsap === false && (
            <Box mb={2.5}>
              <Box
                display={{ xs: 'block', sm: 'inline' }}
                pr={{ xs: 0, sm: 1.25 }}
              >
                <DatePicker
                  id="pickup-date"
                  value={selectedDate}
                  options={fulfillmentDateOptions}
                  label="Date"
                  onDateChange={handleDateChange}
                  dataTestId="pickup-date"
                />
              </Box>
              <Box
                display={{ xs: 'block', sm: 'inline', md: 'inline' }}
                pl={{ xs: 0, sm: 1.25 }}
                mt={{ xs: 2.5, sm: 0 }}
              >
                <TimePicker
                  id="pickup-time"
                  name="pickup-time"
                  disabled={selectedDate === null}
                  label="Time"
                  value={
                    selectedTime
                      ? moment(selectedTime, HOUR_MINUTE_SECONDS).format(
                          MILITARY_TIME
                        )
                      : ''
                  }
                  onChange={handleTimeChange}
                  options={fulfillmentHourOptions}
                />
              </Box>
            </Box>
          )}
          {!areCartItemsAvailable && (
            <Box mb={2.5}>
              <ErrorMessageTypography variant={ITEM_DESCRIPTION_AND_PRICES}>
                The items in your cart are not available for this time. Your
                cart will be cleared when you update.
              </ErrorMessageTypography>
            </Box>
          )}

          <PrimaryCta
            label={!areCartItemsAvailable ? 'Set Time' : primaryButtonLabel}
            type="submit"
            disabled={isDisabled}
            fullWidth={true}
            dataTestId="location-detail-next-button"
            allowPreview
          />
        </form>
      </Box>
    );
  }
}

export default LocationDateTime;
